import React from "react";
import ReactiveComponent from "@usereactify/search-internals/lib/components/basic/ReactiveComponent";

import { useReactifySearchContext } from "../../hooks";
import { getPropsSensorCustom } from "../../utility/props";

export const SensorCustom: React.FC = () => {
  const reactifySearchContext = useReactifySearchContext();
  const reactiveProps = getPropsSensorCustom({
    config: reactifySearchContext.config,
    provider: reactifySearchContext.options,
  });

  return (
    <>
      {reactiveProps.map((props, index) => 
        <ReactiveComponent
          key={`SensorCustom_${index}`}
          {...props}
        />
      )}
    </>
  );
};
